import { render, staticRenderFns } from "./GlobalFilters.vue?vue&type=template&id=3076625d&scoped=true"
import script from "./GlobalFilters.vue?vue&type=script&lang=js"
export * from "./GlobalFilters.vue?vue&type=script&lang=js"
import style0 from "./GlobalFilters.vue?vue&type=style&index=0&id=3076625d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076625d",
  null
  
)

export default component.exports